import React, { Component } from 'react';

import _ from 'lodash';

import { connect } from 'react-redux';
import {logout} from '../../actions/security';
import Translator from '../../translations';

import {Loader} from 'react-loaders';
import { Button, Modal, } from 'react-bootstrap';

class  Logout extends Component {

  state = {
    showModal: true,
    logginout: false,
  }
  close = () =>{
    this.props.history.goBack();
  }

  logout = () =>{
    this.setState({logginout:true});
    setTimeout(() =>{
      this.props.logout(this.props.apiKey);
      this.props.history.push("/");
    },_.random(2000,5000))
  }


  render() {

    return (
      <div className="container-fluid margin-top-40 margin-bottom-40">
      <Modal show={this.state.showModal} dialogClassName="flat" onHide={(e) => console.warn(e)} className="flat">
        <Modal.Header >
          <Modal.Title>{Translator.t('alert_log_out.title')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{textAlign:'center', marginTop:40, marginBottom:40,}}>
            {
                !this.state.logginout   &&
                  <h4>{Translator.t('alert_log_out.message')}</h4>
            }

            {
              this.state.logginout   &&
                <Loader type="ball-pulse-rise" size='lg' styles={{width:45, height:45,}}/>
            }
          </div>
          </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="success" onClick={this.close}>{Translator.t("alert_log_out.actions.cancel")}</Button>
          <Button bsStyle="danger" onClick={this.logout}>{Translator.t("alert_log_out.actions.log_out")}</Button>
        </Modal.Footer>
      </Modal>

      </div>
    );
  }
}


function bindAction(dispatch) {
    return {
      logout:apiKey => dispatch(logout(apiKey)),
    };
}

const mapStateToProps = state => ({
  user: state.security.user,
  apiKey: state.security.user  ? state.security.user.apiKey : null ,
});

export default connect(mapStateToProps, bindAction)(Logout);



// WEBPACK FOOTER //
// ./src/components/security/Logout.js